import { apiRequest } from "../lib/apiClient";
import { API_BASE_URL } from "../env";
import type { BrandingAssetOut, TenantBrandingOut, TenantBrandingUpdate } from "./types";

/** `backend/app/api/v1/branding.py` — §11.1. `GET /branding` is open to any authenticated
 * role; the rest are OWNER-only server-side (mirrored in `roles/permissions.ts`). */

export function getBranding(accessToken: string): Promise<TenantBrandingOut> {
  return apiRequest<TenantBrandingOut>("/branding", { accessToken });
}

export function updateBranding(accessToken: string, body: TenantBrandingUpdate): Promise<TenantBrandingOut> {
  return apiRequest<TenantBrandingOut>("/branding", { method: "PATCH", accessToken, body });
}

async function uploadAsset(accessToken: string, path: string, file: File): Promise<BrandingAssetOut> {
  const formData = new FormData();
  formData.append("file", file);
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method: "POST",
    headers: { Authorization: `Bearer ${accessToken}` },
    body: formData,
  });
  if (!response.ok) {
    const body = (await response.json().catch(() => null)) as { detail?: string } | null;
    throw new Error(body?.detail ?? `Upload failed with status ${response.status}`);
  }
  return (await response.json()) as BrandingAssetOut;
}

export function uploadLogo(accessToken: string, file: File): Promise<BrandingAssetOut> {
  return uploadAsset(accessToken, "/branding/logo", file);
}

export function uploadFavicon(accessToken: string, file: File): Promise<BrandingAssetOut> {
  return uploadAsset(accessToken, "/branding/favicon", file);
}
